import React from 'react'
import { IOrderItem } from 'orders/schema'
import ItemSection from './components/itemSection'
import SectionDataGrid from './components/sectionDataGrid'
import { useGetApfConfigQuery } from 'orders/reduxQueries'
import APFInput from './components/apfInput'
import './styles.scss'
import { snakeCase } from 'lodash'

const ItemAPFSection = ({
    item,
    isItemSelected,
    accountSlug,
    isItemCanceledRefunded,
}: {
    item: IOrderItem
    isItemSelected: boolean
    accountSlug: string
    isItemCanceledRefunded: boolean
}) => {
    const { data } = useGetApfConfigQuery({ accountSlug })
    const [editable, setEditable] = React.useState(true)

    const getDataFields = () => {
        return Object.entries(item.afterPaymentForm).map(([key, value]) => {
            // lodash snakeCase strips existing underscores, so we split by them,
            // snake_case each part, and rejoin with __ (trailing _ stays single).
            const fieldName = key.includes('_')
                ? (() => {
                    const trailingUnderscore = key.endsWith('_')
                    const parts = key.split('_').filter(Boolean).map((part) => snakeCase(part))
                    const result = parts.join('__')
                    return trailingUnderscore ? result + '_' : result
                })()
                : snakeCase(key)
            const field = data?.fieldsConfig.find((field) => field.name === fieldName)
            if (!field) {
                return {
                    name: fieldName,
                    value,
                }
            }

            const translation = field.translations['en']
            const name = translation ? translation.label : fieldName
            const placeholder = translation ? translation.placeholder : ''

            return {
                name: name,
                value: (
                    <APFInput
                        item={item}
                        accountSlug={accountSlug}
                        fieldName={fieldName}
                        placeholder={placeholder}
                        type={field.type}
                        value={value}
                        editable={editable}
                        setEditable={setEditable}
                    />
                ),
            }
        })
    }

    return (
        <ItemSection
            sectionName="Personal details"
            isItemSelected={isItemSelected}
            isItemCanceledRefunded={isItemCanceledRefunded}
            expanded={false}
        >
            <SectionDataGrid dataItems={getDataFields()} />
        </ItemSection>
    )
}

export default ItemAPFSection
